import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

interface ChecklistResponse {
    id: number;
    checklist_name: string;
    percentage: number;
    scoring_level: {
        label: string;
        color: string;
    };
    status: string;
    completed_at: string;
}

interface ResponseFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

interface Props {
    responses: ChecklistResponse[];
    totalRows: number;
    loading?: boolean;
    viewResult?: (id: number) => void;
    filter: ResponseFilters;
    setFilter: (filter: ResponseFilters) => void;
}

const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-CL', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const MyResponsesDataTable = ({
    responses,
    totalRows,
    loading = false,
    viewResult,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'Checklist',
            selector: (row: any) => row.checklist_name,
            sortable: true,
            sortField: 'checklist_name',
            cell: (row: ChecklistResponse) => (
                <strong>{row.checklist_name}</strong>
            )
        },
        {
            name: 'Resultado',
            selector: (row: any) => row.percentage,
            sortable: true,
            sortField: 'percentage',
            cell: (row: ChecklistResponse) => (
                <div className="d-flex align-items-center">
                    <div 
                        className="progress me-2" 
                        style={{ width: '80px', height: '18px', borderRadius: '4px' }}
                    >
                        <div 
                            className="progress-bar" 
                            role="progressbar" 
                            style={{ 
                                width: `${row.percentage}%`,
                                backgroundColor: row.scoring_level?.color || '#6c757d'
                            }}
                        />
                    </div>
                    <span className="fw-bold">{row.percentage}%</span>
                </div>
            )
        },
        {
            name: 'Nivel',
            selector: (row: any) => row.scoring_level?.label,
            sortable: false,
            cell: (row: ChecklistResponse) => (
                <span 
                    className="badge"
                    style={{ backgroundColor: row.scoring_level?.color || '#6c757d' }}
                >
                    {row.scoring_level?.label || 'Sin clasificar'}
                </span>
            )
        },
        {
            name: 'Fecha',
            selector: (row: any) => row.completed_at,
            sortable: true,
            sortField: 'completed_at',
            cell: (row: ChecklistResponse) => (
                <span className="text-muted">{formatDate(row.completed_at)}</span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: ChecklistResponse) => (
                <div className="d-flex align-items-center">
                    {viewResult && (
                        <ButtonTableAction
                            callbackFunction={() => viewResult(row.id)}
                            title="Ver Resultado"
                            classIcon="fa-eye"
                            colorIcon="text-info"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={responses}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default MyResponsesDataTable;

